/**
 * @component Badge
 * @description Kompaktes Label/Tag-Element mit Farbvarianten.
 * Verwendet fuer Kategorien, Segmente und Status-Anzeigen.
 *
 * @prop {string}    [variant='default'] - Farbvariante (default, success, warning, error, info, segment-a/b/c)
 * @prop {ReactNode} children            - Inhalt des Badges
 * @prop {string}    [className]         - Optionale CSS-Klassen
 * @prop {boolean}   [dot=false]         - Ob ein Punkt-Indikator angezeigt wird
 * @usage Verwendet in Tabellen, TaskWidget, Detailseiten fuer Tags und Labels
 */
const VARIANTS = {
  default:     'bg-surface-elevated text-[var(--text-secondary)]',
  success:     'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  warning:     'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  error:       'bg-red-500/10 text-red-600 dark:text-red-400',
  info:        'bg-primary-500/10 text-primary-600 dark:text-primary-400',
  'segment-a': 'bg-primary-500/10 text-primary-600 dark:text-primary-400',
  'segment-b': 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
  'segment-c': 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
};

export function Badge({ variant = 'default', children, className = '', dot = false }) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-badge text-[11px] font-medium ${VARIANTS[variant] || VARIANTS.default} ${className}`}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
